import { createSlice } from '@reduxjs/toolkit'
import navigationConfigFile from 'configs/navigation.config'
import appConfig from 'configs/app.config'

const isMock = process.env.NODE_ENV !== 'production' && appConfig.enableMock

export const initialState = {
    avatar: '',
    userName: isMock ? 'Mock User' : '',
    email: '',
    authority: [],
    permissionsList: [],
    navigationConfig: navigationConfigFile,
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (_, action) => action.payload,
        userLoggedOut: () => initialState,
        forceMockHydration: (state) => {
            state.userName = 'Mock User'
            state.navigationConfig = navigationConfigFile
        },
    },
})

export const { setUser, forceMockHydration } = userSlice.actions

export default userSlice.reducer
